module.exports = __webpack_public_path__ + "img/block-768.a83b478b.jpg";